import { render, staticRenderFns } from "./PartnerErrorAlert.vue?vue&type=template&id=409900db&scoped=true&"
import script from "./PartnerErrorAlert.vue?vue&type=script&lang=js&"
export * from "./PartnerErrorAlert.vue?vue&type=script&lang=js&"
import style0 from "./PartnerErrorAlert.vue?vue&type=style&index=0&id=409900db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409900db",
  null
  
)

export default component.exports